export const stripEnding = (pathname: string, seg: string) =>
  pathname.replace(new RegExp(`/(?:${seg})(?:/)?$`), '')

export const join = (base: string, seg: string) => `${base.replace(/\/+$/, '')}/${seg.replace(/^\/+/, '')}`
